import React from 'react'

import { useLocale, useLocaleCode } from './context'
import { LiveLanguageCodes } from './types'

type Props = {
  children: React.ReactNode
  locales: LiveLanguageCodes[]
}

export const ShowForLocale = ({ children, locales }: Props) => {
  const localeCode = useLocaleCode()

  if (!localeCode) {
    return null
  }

  if (locales.includes(localeCode)) {
    return <>{children}</>
  }

  return null
}

export const HideForLocale = ({ children, locales }: Props) => {
  const localeCode = useLocaleCode()

  if (!localeCode) {
    return <>{children}</>
  }

  if (locales.includes(localeCode)) {
    return null
  }

  return <>{children}</>
}

/**
 * Development-only component to display locale information
 * Can be conditionally shown in development environments
 */
export const LocaleDebug = () => {
  const { resolvedLocale, fullLocale, updateLocale } = useLocale()

  const [activeLocaleCode, setActiveLocaleCode] = React.useState(
    resolvedLocale.localeCode,
  )
  const [isMinimised, setIsMinimised] = React.useState(false)

  if (typeof window === 'undefined') {
    return null
  }

  const enableDebug =
    process.env.NODE_ENV === 'development' ||
    new URL(window.location.href).hostname.includes('s101')

  if (!enableDebug) {
    return null
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        background: 'rgba(0, 0, 0, 0.8)',
        color: 'white',
        padding: '8px 12px',
        borderRadius: '4px',
        fontSize: '12px',
        fontFamily: 'monospace',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        🌍 {fullLocale.flag} {fullLocale.name}
        <button
          style={{
            border: 'none',
            background: 'transparent',
            padding: '0',
            marginLeft: '8px',
            color: 'white',
            cursor: 'pointer',
          }}
          onClick={() => setIsMinimised(!isMinimised)}
        >
          {isMinimised ? '＋' : '—'}
        </button>
      </div>
      {!isMinimised && (
        <>
          <div>Locale: {resolvedLocale.localeCode}</div>
          <div>Source: {resolvedLocale.source.name}</div>
          {resolvedLocale.fromCookie && <div>From Cookie: ✅</div>}
          <div style={{ display: 'flex', marginTop: '8px' }}>
            <select
              name="availableLocales"
              style={{ flex: '1 1 auto', cursor: 'pointer' }}
              value={activeLocaleCode}
              onChange={(e) => {
                setActiveLocaleCode(e.target.value as LiveLanguageCodes)
              }}
            >
              <option value="en-GB">English</option>
              <option value="en-US">English (US)</option>
              <option value="en-IE">English (IE)</option>
              <option value="en-ES">English (ES)</option>
              <option value="es-ES">Spanish</option>
            </select>
            <button
              style={{ backgroundColor: 'lightgrey', cursor: 'pointer' }}
              onClick={() => {
                console.info('Overriding locale to:', activeLocaleCode)
                updateLocale(activeLocaleCode)
              }}
            >
              Update
            </button>
          </div>
        </>
      )}
    </div>
  )
}
